<ng-container>
  <h2><ng-content></ng-content></h2>
  <hr />
</ng-container>
